import { createUseStyles } from 'react-jss'
import { componentsGap } from '../constants'

const useStyles = createUseStyles({
    heroImageContainer: {
        marginTop: `-${componentsGap}px`
    }
})

export default useStyles
